module.exports = __webpack_public_path__ + "static/media/star-of-life.c59ebbbc.svg";